import React, { FC, useEffect, useState } from 'react';
import { Alert, Button, Modal } from 'react-bootstrap';
import { FormatTime } from '../Utilities';

interface EndModalProps {
    show: boolean;
    score: number;
    wordCount: number;
    playAgain: Function;
}

const EndModal: FC<EndModalProps> = ({ show, score, wordCount, playAgain, children }) => {

    //const [timeRemaining, setTimeRemaining] = useState(0);
    const [showAlert, setShowAlert] = useState(false);
    /*
    useEffect(() => {
        const endModalInterval = setInterval(() => {
            let now = new Date();
            let totalSecondsToday = (now.getHours() * 60 + now.getMinutes()) * 60 + now.getSeconds();
          
            setTimeRemaining(86400 - totalSecondsToday);
        },500);
        return () => clearInterval(endModalInterval);
    }, []);
    */

    return (
        <Modal show={show} onHide={() => {}} backdrop="static">
            <Modal.Header>
                <Modal.Title>Score</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    <span className="endModalScore">{score}</span> points over <span className="endModalScore">{wordCount}</span> words.
                </p>              
                <p>
                    If you enjoy Scordle, please consider <a href="https://www.buymeacoffee.com/joshnewsome78" target="_blank">buying me a coffee.</a>
                </p>
                <Alert variant="success" show={showAlert} onClose={() => setShowAlert(false)}>
                Score copied to clipboard.
                </Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="success" onClick={() => {
                        setShowAlert(false);
                        playAgain();
                    }}>
                    Play Again    
                </Button>
                <Button variant="primary" onClick={share}>
                    Share
                    <svg className="share" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                    <path fill="white" d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92c0-1.61-1.31-2.92-2.92-2.92zM18 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM6 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm12 7.02c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"></path>
                    </svg>
                </Button>
            </Modal.Footer>
        </Modal>
    );

    async function share() {
        if(iOS()) {
            const shareData = {
                title: 'Scoredle',
                text: `Scordle: ${score} points over ${wordCount} words.`,
                url: 'https://scordle.onrender.com'
              }
              await navigator.share(shareData)
        }
        else {
            navigator.clipboard.writeText(`Scordle: ${score} points over ${wordCount} words.\nhttps://scordle.onrender.com`).then(() => {
                setShowAlert(true);
            });
        }
    }

    function iOS() {
        return [
          'iPad Simulator',
          'iPhone Simulator',
          'iPod Simulator',
          'iPad',
          'iPhone',
          'iPod'
        ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      }
};

export default EndModal;